var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',_vm._g(_vm._b({staticClass:"center_text",class:_vm.classes,attrs:{"label":"","small":"","color":_vm.color}},'v-chip',_vm.$attrs,false),_vm.$listeners),[_vm._v(" "+_vm._s(_vm.status)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }